import { RootState } from "@/redux/store"
import { routes } from "@/routes/utils";
import { useSelector } from "react-redux"
import { useGetLifeCycle } from "@/services";
import { createElement } from "react";
import moment from "moment";

const useFiscalYearLifecycle = () => {
  const {currentFinanceYear, communityData} = useSelector((state: RootState) => state.currentData);

  const { 
    data: lifeCycleData, 
    isLoading: isLifeCycleLoading
  } = useGetLifeCycle({                                                                         
      communityId: communityData?.communityId,
      queryParams:{
        enabled: !!communityData?.communityId
      }                                                                                           
    })  
 
  // Define Table Columns
  const columns = [
    {
      accessorKey: "fiscalYear",
      header: "Fiscal Year",
      accessorFn: (row: any) => String(row?.fiscalYear || ""),
    },
    {
      accessorKey: "status",
      header: "Status",
      accessorFn: (row: any) => {
        const status = String(row?.status || "");
        return status.toLowerCase() === "locked" ? "Carry Forward" : status;
      },
      cell: ({ getValue }: any) => {
        const status = String(getValue() || "");
        return createElement(
          "span",
          { className: status.toLowerCase() === "open" ? "text-green-600" : "" },
          status
        );
      },
    },
    {
      accessorKey: "updatedAt",
      header: "Updated At",
      accessorFn: (row: any) =>
        row?.updatedAt ? moment(row?.updatedAt).format("MM/DD/YYYY [at] hh:mm A") : "",
    },
     {
      accessorKey: "updatedByName",
      header: "Updated By",
      accessorFn: (row: any) =>String(row?.updatedByName||""),
        
    },
  ];
  

  const breadcrumbData = [
    {
      link: `/${routes.bom}/${routes.finance}`,
      name: `Activity Dashboard - ${communityData?.communityName || communityData?.name || ""}`,
    },
    {
      link: `/${routes.bom}/${routes.finance}/${routes.generalLedger}`,
      name: `General Ledger`,
    },
    {
      link: "",
      name: "Fiscal Year Life Cycle",
    },
  ];

  return {
    currentFinanceYear,
    columns,
    breadcrumbData,
    communityData,
    data:lifeCycleData||[],
    isLifeCycleLoading
  }
}

export default useFiscalYearLifecycle;
